import { Button, Col, Form, Input, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect, useState } from 'react';
import { useGlobalContext } from '../../context/GlobalContext';

import { ICobrancaCustomDTO, IEstornoDTO } from '../../models/happy-code-api.model';
import { useCobrancaService } from '../../services/cobranca.service';
import { useNotificationService } from '../../services/notification.service';
import { formatMoney, formattedDate } from '../../util/format';
import { TagsFinanceiro } from '../TagsFinanceiro';
import * as Unicons from '@iconscout/react-unicons';
import './style.css';
interface Text {
    open: boolean;
    onClose: () => void;
}

export const ModalNovoAluno: React.FunctionComponent<Text> = ({ open, onClose }: Text) => {

    const notification = useNotificationService();
    const { setIsGlobalLoading } = useGlobalContext();
    //const cobrancaService = useCobrancaService(); -- 'USE' conexão com  o back
    const [isOpenAndAluno, setIsOpenAndAluno] = useState<boolean>(false);
    const [mostrarModalNovoAluno, setMostrarModalNovoAluno] = useState<boolean>(false);


    const closeModalNovoAluno = () => {
        setIsOpenAndAluno(false);
    }

    const fecharModais = () => {
        closeModalNovoAluno();
        onClose();
    }


    {/* PUXA
    const estornaCobranca = () => {
        setIsGlobalLoading(true);
        cobrancaService.estornarCobranca(cobrancaEstornoParcial)
        .then(() => {
            fecharModais();
            notification({
                type: 'success',
                message: `Estorno efetuado com sucesso!`,
            });
            
        })
        .catch()
        .finally(() => {
            setIsGlobalLoading(false);
        });
    }
*/}


    if (!open) return null

    return (
        <div className="modalContainerFinanceiro-estorno">
            <div className="modal-user-financeiro-estorno">
                <div className="body">
                    <h3 style={{ textAlign: 'center' }}>Novo Aluno</h3>

                    <div className="box-tabela" style={{ marginTop: 20 }}>
                        <div className="tabela">
                            <Form.Item
                                style={{ display: "inline-block", marginLeft: "10px" }}
                                label="Nome"
                                name={'estorno-amount'}
                                rules={[{ required: true, message: 'Informe o valor do estorno' }]} >

                                <Input
                                    id="estorno-amount"
                                    className="campo-input-amount"
                                    min={0}
                                    //max={cobranca?.valorCobranca}
                                    required
                                    defaultValue={null}
                                //onChange={(e) => setCobrancaEstornoParcial({ ...cobrancaEstornoParcial, amount: e })}
                                //value={parseFloat(cobrancaEstornoParcial?.amount?.toFixed(3)?.replace(/(\d)(?=(\d{7})+(?!\d))/g, '$.'))} 
                                />
                            </Form.Item>
                            <Form.Item
                                style={{ display: "inline-block", marginLeft: "10px" }}
                                label="Sobrenome"
                                name={'estorno-amount'}
                                rules={[{ required: true, message: 'Informe o valor do estorno' }]} >

                                <Input
                                    id="estorno-amount"
                                    className="campo-input-amount"
                                    min={0}
                                    //max={cobranca?.valorCobranca}
                                    required
                                    defaultValue={null}
                                //onChange={(e) => setCobrancaEstornoParcial({ ...cobrancaEstornoParcial, amount: e })}
                                //value={parseFloat(cobrancaEstornoParcial?.amount?.toFixed(3)?.replace(/(\d)(?=(\d{7})+(?!\d))/g, '$.'))} 
                                />
                            </Form.Item>


                            <Form>
                                <Row className="registro-user">
                                    <Col>
                                        <div className="check-radios">
                                            <div id="check-estorno-parcial">

                                            </div>
                                        </div>

                                        <div className="check-radios">
                                            <div id="check-estorno-parcial">
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>

                        </div>
                    </div>
                </div>

                <div className="line"></div>
                <div className="botoes">
                    <Button onClick={onClose} style={{ minWidth: 145 }} className="estornar-button-second">Voltar</Button>
                </div>
            </div>
            <ModalNovoAluno
                open={isOpenAndAluno}
                onClose={closeModalNovoAluno}
            />
        </div >
    );
}

export default ModalNovoAluno;